import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryMilkQualityType = () => {
  return <CategoryBase baseEndpoint="category_milk_quality_type" />;
};

export default CategoryMilkQualityType;
